// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { Theme, SvgIcon, useTheme } from '@mui/material';

// TYPES ---------------------------------------------------------------- //

interface TileIconAutoProps {
  size?: number;
  useTileCorrections?: boolean;
}

// COMPONENT ---------------------------------------------------------------- //

const TileIconAuto = ({ size = 24, useTileCorrections = true }: TileIconAutoProps) => {
  const theme = useTheme();
  const clsx = useSxStyles(theme);

  return (
    <SvgIcon sx={useTileCorrections ? clsx.iconWithCorrections : clsx.icon} style={{ fontSize: `${size}px` }}>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
        <path fill='none' d='M0 0h24v24H0V0z' />
        <path fill='currentColor' d='M12.04 8.04h-.09l-1.6 4.55h3.29z' />
        <path
          fill='currentColor'
          d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.21 15-.98-2.81H9.78l-1 2.81h-1.9l4.13-11h1.97l4.13 11h-1.9z'
        />
      </svg>
    </SvgIcon>
  );
};

// STYLES ---------------------------------------------------------------- //

const useSxStyles = (theme: Theme) => ({
  icon: {
    display: 'block',
    color: theme.palette.auto.main,
  },
  iconWithCorrections: {
    display: 'block',
    marginBottom: '-3px',
    fontSize: '22px',
    color: theme.palette.auto.main,
  },
});

// EXPORT ---------------------------------------------------------------- //

export default TileIconAuto;
